module.exports = __webpack_public_path__ + "static/media/about-banner@2x.7d31168e.png";